import {
  FETCH_CUSTOMER_RELATED_FROM_INFO_REQUEST,
  FETCH_CUSTOMER_RELATED_FROM_INFO_SUCCESS,
  FETCH_CUSTOMER_RELATED_FROM_INFO_FAILURE,
} from '../../../actions/actionTypes'

import fetchStatusesByCustomerIdReducerCreator from '../higherOrderReducers/reducerCreators/byCustomerId'

export default fetchStatusesByCustomerIdReducerCreator(
  FETCH_CUSTOMER_RELATED_FROM_INFO_REQUEST,
  FETCH_CUSTOMER_RELATED_FROM_INFO_SUCCESS,
  FETCH_CUSTOMER_RELATED_FROM_INFO_FAILURE,
)
